import { useContext } from 'react';
import { resolveRouteUrl } from './resolve';
import { RouteContext } from './context';
/** 当前匹配到的路由信息（含 menu / breadcrumb / layout） */

export const useActiveRoute = () => useContext(RouteContext).match;
/** 全部已展开路由，一般只在 RouteOutlet 中使用 */

export const useResolvedRoutes = () => useContext(RouteContext).routes;
/** 当前路由参数，如 { tenantId: '42' } */

export const useRouteParams = () => useContext(RouteContext).params;
/** 页面里直接取当前租户 id，不必自己解析 URL */

export const useTenantId = () => useContext(RouteContext).params.tenantId;
/**
 * 按路由 key 取真实 URL，参数缺省时沿用当前路由参数。
 * 用于在 NavBar 等全局位置生成作用域入口，避免硬编码路径。
 */

export function useRouteUrl(key, params) {
  const {
    routes,
    params: currentParams
  } = useContext(RouteContext);
  return resolveRouteUrl(routes, key, params ?? currentParams);
}